import { render, staticRenderFns } from "./IAQControlView.vue?vue&type=template&id=3d94ae9c&scoped=true&class=fill-height"
import script from "./IAQControlView.vue?vue&type=script&lang=ts"
export * from "./IAQControlView.vue?vue&type=script&lang=ts"
import style0 from "./IAQControlView.vue?vue&type=style&index=0&id=3d94ae9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d94ae9c",
  null
  
)

export default component.exports